import React, { useState } from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'
import { isEmpty } from 'lodash'
import { Skeleton } from '@material-ui/lab'
import { Box, Paper, Typography } from '@material-ui/core'

import { QuestionCard, StatusTabs } from './components'

import useFetch from 'hooks/useFetch'
import useAuthSupplier from 'hooks/useAuthSupplier'

import * as service from 'service'
import helpers from 'helpers'
import theme from 'theme'
import useStyles from './styles'

const QuestionnairesBoard = () => {
  const [currentTab, setCurrentTab] = useState(null)

  const { loaded, companySupplier } = useAuthSupplier()
  const classes = useStyles()

  const { response, isLoading } = useFetch(
    service.supplierPortal.companySupplierQuestionnaires.get,
    { companySupplierProgressStatus: currentTab },
    [currentTab],
    loaded,
  )

  const companySupplierQuestionnaires =
    response?.data?.companySupplierQuestionnaires

  const filterQuizQuestionTemplates = (allQuizQuestionTemplates) => {
    return currentTab
      ? allQuizQuestionTemplates.filter(
          (quizQuestionTemplate) =>
            helpers.suppliers.companySuppliers.quizQuestionTemplateStatus(
              quizQuestionTemplate,
              companySupplier,
            ) === currentTab,
        )
      : allQuizQuestionTemplates
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <StatusTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
      <Box>
        <PerfectScrollbar
          options={{
            useBothWheelAxes: true,
          }}
          className={classes.boardScrollbar}
        >
          <Box display="flex" gridGap={theme.spacing(2)}>
            {isLoading
              ? [...Array(5)].map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="rect"
                    animation="wave"
                    width={400}
                    height={599}
                  />
                ))
              : companySupplierQuestionnaires?.map(
                  (companySupplierQuestionnaire) => {
                    const questionnaire =
                      companySupplierQuestionnaire?.questionnaire
                    const allQuizQuestionTemplates =
                      companySupplierQuestionnaire?.quizQuestionTemplates || []
                    const quizQuestionTemplates = filterQuizQuestionTemplates(
                      allQuizQuestionTemplates,
                    )

                    return (
                      <Box
                        key={questionnaire?.id}
                        height={600}
                        display="flex"
                        flexDirection="column"
                      >
                        <Box className={classes.boardHeader}>
                          <Typography variant="h5">
                            {questionnaire?.kind}
                          </Typography>
                        </Box>
                        <Box className={classes.boardContent}>
                          <PerfectScrollbar
                            options={{
                              wheelPropagation: true,
                              useBothWheelAxes: true,
                            }}
                            className={classes.scrollbar}
                          >
                            <Box className={classes.boardBody}>
                              {isEmpty(quizQuestionTemplates) ? (
                                <Paper
                                  variant="outlined"
                                  className={classes.notFoundQuestions}
                                >
                                  <Typography>
                                    Nenhuma questão encontrada.
                                  </Typography>
                                </Paper>
                              ) : (
                                quizQuestionTemplates?.map(
                                  (quizQuestionTemplate) => (
                                    <QuestionCard
                                      key={quizQuestionTemplate?.id}
                                      companySupplierQuestionnaireId={
                                        companySupplierQuestionnaire?.id
                                      }
                                      quizQuestionTemplate={
                                        quizQuestionTemplate
                                      }
                                    />
                                  ),
                                )
                              )}
                            </Box>
                          </PerfectScrollbar>
                        </Box>
                      </Box>
                    )
                  },
                )}
          </Box>
        </PerfectScrollbar>
      </Box>
    </Box>
  )
}

export default QuestionnairesBoard
